import { LoadingPage } from '@src/common/components/LoadingPage';
import type { Order } from '@src/orders/domain/Order';
import { useClient } from '@src/orders/hooks/useClient';
import { useOrder } from '@src/orders/hooks/useOrder';
import { ViewOrder } from '@src/orders/ViewOrder';
import { useTranslation } from 'react-i18next';

export interface Props {
  orderId: string;
}

export const ViewOrderProvider = ({ orderId }: Props) => {
  const { t } = useTranslation();

  const { isLoading, order } = useOrder({ id: orderId });
  if (isLoading) {
    return <LoadingPage />;
  }
  if (!order) {
    return <>{t('loadingError')}</>;
  }

  return <PartiallyLoadedOrder order={order} />;
};

const PartiallyLoadedOrder = ({ order }: { order: Order }) => {
  const { t } = useTranslation();

  const { isLoading: isClientLoading, client } = useClient({
    id: order.clientId,
  });
  if (isClientLoading) {
    return <LoadingPage />;
  }
  if (!client) {
    return <>{t('loadingError')}</>;
  }

  return <ViewOrder order={order} client={client} />;
};
